import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-packaging-table',
  templateUrl: './packaging-table.component.html',
  styleUrls: ['./packaging-table.component.css']
})

export class PackagingTable implements OnInit{
  constructor(
    private modal: NgbModal,
  ){}

  @Input()
  packagings: any;

  @Input()
  me: any;

  @Input()
  followId: any;

  @Output()
  downloads = new EventEmitter()

  @Output()
  uploads = new EventEmitter()

  @Output()
  downloadAllSupplier = new EventEmitter()

  @Output()
  uploadsMassives = new EventEmitter()

  @Output()
  changeFollowIds = new EventEmitter()

  isShowSupplier = false;
  currentIndexSupplier = null;
  currentProviderId = null;
  currentSupplierPack = [];
  _modalObservation = null;

  get show(){
    return this.me && (this.me.role === 'product-manager' || this.me.role === 'merchant')  
  }

  ngOnInit(): void {
  }

  download(e,suppplierInfo?){
    const data = {
      ProviderId: null,
      downloadMode: 'providerMode',
      followId: e.followId,
      packagingId: e.id,
      providerName: null,
      suppplierInfo: suppplierInfo
    }
    this.downloads.emit(data)
  }

  downloadAll(e){
    if(this.me && this.me.role === 'supplier'){
      this.download(e)
    }else{
      this.downloadAllSupplier.emit(e.id)
    }
  }

  uploadMassive(e, pack){
    if(this.me && this.me.role === 'supplier'){
      this.changeFileInput(e,pack)
    }else{
      if (e.target.files) {
        const files = e.target.files;
  
        if (files && files[0]) {
          this.uploadsMassives.emit({ file: files[0], packagingId: pack.id, type: 'packagingMassiveProviders' })
        }
  
        e.target.value = null;
      }
    }
  }

  changeFileInput(e, data){
    if (e.target.files) {
      const files = e.target.files;

      if (files && files[0]) {
        this.uploads.emit({ file: files[0], packagingId: data.id, type: 'providerType' })
      }

      e.target.value = null;
    }
  }

  showSupplierPack(pack, index){
    if(pack && this.currentProviderId !== pack.id){
      this.currentProviderId = pack.id
      this.isShowSupplier = true
      this.currentIndexSupplier = index
      this.currentSupplierPack = pack.providersWithFieldsCount
    }else{
      this.currentProviderId = null
      this.isShowSupplier = false
      this.currentIndexSupplier = null
      this.currentSupplierPack = []
    }
  }
}


